<template>
  <div class="main-wrapper">
    <layout-header />
    <layout-sidebar />

    <div class="page-wrapper">
      <div class="content container-fluid scheduler-wrapper">

        <div class="scheduler">

          <!-- FIXED PALETTE -->
          <div class="palette-fixed">
            <div ref="palette" class="palette-row">
              <div
                v-for="s in shifts"
                :key="s.id"
                class="shift-box"
                :style="{ background: s.color }"
                :data-id="s.id"
              >
                <b>{{ s.name }}</b>
                <small>{{ s.time }}</small>
              </div>
            </div>
          </div>

          <!-- SCROLL AREA -->
          <div class="scheduler-scroll">

            <!-- HEADER -->
            <div class="grid">
              <div class="cell head emp">Scheduled Shift</div>
              <div class="cell head" v-for="d in days" :key="d">{{ d }}</div>
            </div>

            <!-- ROWS -->
            <div v-for="emp in employees" :key="emp.id" class="grid row">
              <div class="cell emp">👤 {{ emp.name }}</div>
              <div
                v-for="day in days"
                :key="day"
                class="cell drop-cell"
                :ref="el => registerCell(el, emp.id, day)"
              ></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Sortable from "sortablejs";

const palette = ref(null);
const cellMap = new Map();

const days = ["Mon 29","Tue 30","Wed 31","Thu 1","Fri 2","Sat 3","Sun 4"];

const shifts = ref([
  { id: 1, name: "Evening Shift", time: "03:00 - 13:00", color: "#cbd3ff" },
  { id: 2, name: "Morning Shift", time: "07:00 - 16:00", color: "#f8c8ff" },
  { id: 3, name: "Night Shift", time: "23:00 - 06:00", color: "#e5d9cf" },
  { id: 4, name: "Housekeeping", time: "Not Set", color: "#ffd6df" }
]);

const employees = ref([
  { id: 1, name: "Aatif Shaikh" },
  { id: 2, name: "Admin A" },
  { id: 3, name: "Bhavik Patel" },
  { id: 4, name: "Jasmine Carter" }
]);

onMounted(() => {

  Sortable.create(palette.value, {
    group: { name: "shifts", pull: "clone", put: false },
    sort: false,
    animation: 150
  });

  setTimeout(() => {
    cellMap.forEach(cell => {
      Sortable.create(cell.el, {
        group: "shifts",
        animation: 180,
        onAdd(evt){
          const id = evt.item.dataset.id;
          const shift = shifts.value.find(s => s.id == id);
          evt.item.innerHTML = `
            <div class="assigned" style="background:${shift.color}">
              <div class="assigned-title">${shift.name}</div>
              <div class="assigned-time">${shift.time}</div>
            </div>`;
        }
      });
    });
  }, 0);
});

const registerCell = (el, emp, day) => {
  if (el) cellMap.set(emp + "-" + day, { el, emp, day });
};
</script>

<style scoped>

.scheduler{
  padding:20px;
  font-family:Segoe UI;
  --dayWidth:190px;
}

.palette-fixed{position:sticky;top:0;z-index:10}

.scheduler-scroll{overflow-x:auto}

/* Palette */
.palette-row{display:flex;gap:12px;margin-bottom:15px}

.shift-box{
  width:190px;
  padding:14px;
  border-radius:12px;
  cursor:grab;
  box-shadow:0 3px 8px rgba(0,0,0,.12)
}

/* Grid */
.grid{
  display:grid;
  grid-template-columns:220px repeat(7, var(--dayWidth));
}
.grid > .cell{min-width:190px}

.cell{border-bottom:1px solid #eee;padding:10px;text-align:center}
.head{background:#fafafa;font-weight:600;border-bottom:2px solid #ddd}
.emp{text-align:left;font-weight:600}

/* Drop cell */
.drop-cell{
  min-height:65px;
  border:1px dashed #ddd;
  border-radius:8px;
  display:flex;
  flex-direction:column;
  gap:4px;
  padding:4px;
}

.drop-cell:empty::after{
  content:"+";
  color:#cfcfcf;
  font-size:22px;
  display:flex;
  justify-content:center;
  align-items:center;
  height:65px;
}

/* Assigned */
.assigned{
  width:100%;
  padding:6px 10px;
  border-radius:8px;
  font-size:12px;
  text-align:left;
}
.assigned-title{font-weight:600}
.assigned-time{font-size:11px;opacity:.75}

/* Mobile */
@media (max-width:600px){
  .grid{grid-template-columns:1fr}
  .grid.header{display:none}
  .grid.row{border:1px solid #ddd;margin-bottom:12px;border-radius:10px;padding:10px}
}

.shift-box b,
.shift-box small{
  display:block;
}

.assigned-title,
.assigned-time{
  display:block;
}

</style>
